@if (isVisible && liveVideoData) {
  <div
    #videoContainer
    class="live-video-container"
    [class.minimized]="isMinimized"
    [class.maximized]="isMaximized"
    [style.left.px]="position.x"
    [style.top.px]="position.y"
    (mousedown)="onMouseDown($event)"
    >
    @if (!isMinimized) {
      <div class="video-content" [class.playing]="isPlaying">
        <div class="livestream-info-overlay">
          <div class="left-section">
            <!-- Current Bid Display -->
            @if (isMaximized) {
              <div class="current-bid-overlay">
                <div class="bid-label">CURRENT BID :</div>
                <div class="bid-amount">
                  ${{ liveVideoData.current_bid || "15000" | number : "1.0-0" }}
                </div>
              </div>
            }
            @if (!isMaximized) {
              <button class="back-to-tab">Back to tab</button>
            }
          </div>
          <div class="right-section">
            <div class="status-indicator {{ auctionStatus }}">
              {{ auctionStatus }}
            </div>
            <div class="controls-group">
              <button
                class="control-btn maximize-btn"
                (click)="toggleMaximize()"
                [title]="isMaximized ? 'Restore' : 'Maximize'"
                >
                @if (!isMaximized) {
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    >
                    <path
                      d="M3 3h6v6H3V3z"
                      stroke="currentColor"
                      stroke-width="1.5"
                      fill="none"
                      />
                      <path
                        d="M5 5h4v4"
                        stroke="currentColor"
                        stroke-width="1.5"
                        fill="none"
                        />
                      </svg>
                    }
                    @if (isMaximized) {
                      <svg width="12" height="12" viewBox="0 0 12 12">
                        <path
                          d="M4 4h4v4H4V4z"
                          stroke="currentColor"
                          stroke-width="1.5"
                          fill="none"
                          />
                          <path
                            d="M6 2h4v4"
                            stroke="currentColor"
                            stroke-width="1.5"
                            fill="none"
                            />
                          </svg>
                        }
                      </button>
                      <button
                        class="control-btn mute-btn"
                        [class.muted]="isMuted"
                        (click)="toggleMute()"
                        [title]="isMuted ? 'Unmute' : 'Mute'"
                        >
                        <!-- Muted Icon -->
                        @if (isMuted) {
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            >
                            <path
                              d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
                              />
                            </svg>
                          }
                          <!-- Unmuted Icon -->
                          @if (!isMuted) {
                            <svg
                              width="12"
                              height="12"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                              >
                              <path
                                d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
                                />
                              </svg>
                            }
                          </button>
                          <button
                            class="control-btn close-btn"
                            (click)="closeLiveVideo()"
                            title="Close"
                            >
                            <svg width="12" height="12" viewBox="0 0 12 12">
                              <path
                                d="M9 3L3 9M3 3l6 6"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                      <video #videoPlayer class="video-player" playsinline muted autoplay></video>
                      <!-- Play/Pause Control Overlay -->
                      <div class="play-pause-overlay">
                        @if (!isPaused) {
                          <button
                            class="play-pause-btn"
                            (click)="togglePlayPause()"
                            >
                            <!-- Play Icon -->
                            @if (!isPlaying) {
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                >
                                <path d="M8 5v14l11-7z" />
                              </svg>
                            }
                            <!-- Pause Icon -->
                            @if (isPlaying) {
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                >
                                <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" />
                              </svg>
                            }
                          </button>
                        }
                        @if (isPaused) {
                          <div class="pause-auction">Auction Paused</div>
                        }
                      </div>
                      <!-- <div class="video-info" *ngIf="liveVideoData.auction_name">
                      <span class="auction-name">{{ liveVideoData.auction_name }}</span>
                    </div> -->
                  </div>
                }
              </div>
            }
